import { PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import providers from "@/lib/api";

export default function usePaymentPackage() {
  const findAll = (type?: PaymentPackageEnum[]) => {
    return providers.PaymentPackageProvider.findAll({ type });
  };

  return {
    findAll,
  };
}
